import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../form/Button';

const AudioPreview = (props) => {
  const [playing, setPlaying] = useState(false);
  const [error, setError] = useState(false);
  const [src, setSrc] = useState();

  const audio = useRef();

  const togglePlay = useCallback(() => {
    if (!playing) {
      audio.current.play();
    } else {
      audio.current.pause();
    }

    setPlaying(!playing);
  }, [playing]);

  const handleAudioEnd = useCallback(() => {
    setPlaying(false);
  }, []);

  const handleError = useCallback(() => {
    setError(true);
  }, []);

  useEffect(() => {
    if (props.src instanceof File) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setSrc(e.target.result);
      };
      reader.readAsDataURL(props.src);
    } else {
      setSrc(props.external ? props.src : `${process.env.REACT_APP_FILES_URL}/${props.src}`);
    }
  }, [props.src, props.external]);

  return (
    <div
      style={{
        display: 'inline-block',
      }}
    >
      <Button
        tooltip="Play/Pause"
        onClick={togglePlay}
        disabled={error}
        size={props.size}
        icon={error ? 'exclamation-circle' : playing ? 'pause' : 'caret-right'}
      />
      <audio
        src={src}
        muted={false}
        controls={false}
        ref={audio}
        onEnded={handleAudioEnd}
        onPause={handleAudioEnd}
        onError={handleError}
        style={{
          visibility: 'hidden',
          width: 0,
          height: 0,
        }}
      />
    </div>
  );
};

AudioPreview.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]).isRequired,
  size: Button.propTypes.size,
  external: PropTypes.bool,
};

AudioPreview.defaultProps = {
  size: 'md',
  external: false,
};

export default AudioPreview;
